import Legals from '../Legals';
import { EArticleAlias } from '../types';

export const getLegalComponent = (legalsType: string, height: number) => (
  <Legals className="legals-frame" type={legalsType as EArticleAlias} height={height} />
);
